import { render } from "./EventCenter.vue?vue&type=template&id=5b466f90"
import script from "./EventCenter.vue?vue&type=script&lang=js"
export * from "./EventCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__